import OrganizationListPageConstants from './OrganizationListPageConstants';

export function changeFilters(filters) {
  return { type: OrganizationListPageConstants.CHANGE_ORGANIZATIONS_FILTERS, filters };
}
